import _ from 'underscore';
import moment from 'moment';

import SEGMENT_TRACKING_EVENTS from 'constants/segmentEvents';

function PerformanceGuestListCtrl($scope, $stateParams, $location, $q, $sce, venueService, sdkUtils, admissionGroupService, attributionSourceService, attributionSourceReportService, permissionService, organizationService, managementUserOrganizationMemberService, alertService, utilsService, dateUtilsService, pubsubService, ERROR_MESSAGES, TRACKING_EVENT_CATEGORIES, reportService) { //eslint-disable-line
  const ALL_VENUES_ID = 'ALL_VENUES_ID';
  const ALL_ATTRIBUTION_ID = 'ALL_ATTRIBUTION_ID';
  const currentUserOrganization = organizationService.getCurrentOrganization();

  //TODO: handle having no venues
  let initialAdmissionGroupLoad = true;
  let initialAttributionLoad = true;

  function _initScope() {
    $scope.stats = {};
    $scope.highchartsOptions = {};
    $scope.viewTypes = [{
      key: 'All Guestlists',
      value: 'ALL_GUESTLISTS'
    }, {
      key: 'Guestlists By User',
      value: 'GUESTLISTS_BY_USER'
    }];

    $scope.currentViewType = $scope.viewTypes[0].value;

    //enums
    $scope.TRACKING_EVENT_CATEGORIES = TRACKING_EVENT_CATEGORIES;
    $scope.SEGMENT_TRACKING_EVENTS = SEGMENT_TRACKING_EVENTS;

    $scope.guestlistData = [];
    // $scope.loading = true;
    $scope.exportData = _exportData;
    $scope.filterUsersForm = {
      venue: null,
      attributionSource: null
    };

    /**
     * @desc jQuery Data Table options
     */
    $scope.guestlistDataTableOptions = {
      paginationType: 'full_numbers',
      displayLength: 50,
      columnDefs: [{
        visible: false,
        targets: 0
      }],
      order: [
        [0, 'asc']
      ]
    };

    $scope.guestlistByUserDataTableOptions = {
      paginationType: 'full_numbers',
      displayLength: 25
    };

    $scope.guestlistDataTableInstance = {};
    $scope.guestlistByUserDataTableInstance = {};

    $scope.$watchGroup(['filterUsersForm.venue', 'filterUsersForm.attributionSource'], function() {
      if (initialAdmissionGroupLoad || initialAttributionLoad) return; //prevent this from firing before admission groups have been loaded the first time

      _refreshReport();
    });

    $scope.getUserCoverTooltip = function(user) {
      if (!user) return null;

      let html = '';

      _.each(user.covers, function(cover) {
        html += cover.toUpperCase() + '<br>'; //eslint-disable-line
      });

      return html;
    };

    $scope.dateRangePicker = {
      options: {
        ranges: {
          'This Week': [moment().startOf('week'), moment().endOf('week')],
          'Last Week': [moment().day(-6), moment().day(0)],
          'This Month': [moment().startOf('month'), moment().endOf('month')],
          'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
          'Next 3 Months': [moment(), moment().add(3, 'month')],
          'Last 3 Months': [moment().subtract(3, 'month'), moment()]
        },
        locale: {
          format: 'ddd, MMM. Do YYYY'
        },
        linkedCalendars: false,
        alwaysShowCalendars: true,
        parentEl: '.date-range-wrapper',
        opens: 'left'
      }
    };

    $scope.$watch('dateRangePicker.date', () => {
      if (initialAdmissionGroupLoad) return;

      _refreshReport();

      syncLocationStartEnd();
    });

    /**
     * @desc Date range initial date
     */
    $scope.dateRangePicker.date = {
      startDate: $stateParams.start ? moment(parseInt($stateParams.start, 10)) : $scope.dateRangePicker.options.ranges['Last Week'][0].clone(),
      endDate: $stateParams.end ? moment(parseInt($stateParams.end, 10)) : $scope.dateRangePicker.options.ranges['Last Week'][1].clone()
    };

    syncLocationStartEnd();
  }

  function syncLocationStartEnd() {
    $location.search({
      start: $scope.dateRangePicker.date.startDate.format('x'),
      end: $scope.dateRangePicker.date.endDate.format('x')
    });
  }

  function _loadData() {
    return $scope.venuesPromise
      .then(() => {
        $scope.filterUsersForm.venue = $scope.venues[0];

        return $scope.getAdmissionGroupStatsByOrganizationId(dateUtilsService.toUTCMomentWithoutTime($scope.dateRangePicker.date.startDate), dateUtilsService.toUTCMomentWithoutTime($scope.dateRangePicker.date.endDate));
      })
      .then(() => {
        _getAttributionSources()
          .then(() => {
            initialAttributionLoad = false;
          });

        return _getAdmissionGroups();
      })
      .then(() => {
        initialAdmissionGroupLoad = false;
        $scope.loading = false;
      });
  }

  function _getAttributionSources() {
    return attributionSourceService.listByOrganizationId(currentUserOrganization.id)
      .then(attributionSources => {
        $scope.attributionSources = attributionSources;

        $scope.attributionSources.unshift({
          id: ALL_ATTRIBUTION_ID,
          name: 'All Users'
        });

        $scope.filterUsersForm.attributionSource = $scope.attributionSources[0];
      })
      .catch(response => {
        alertService.error(sdkUtils.getErrorFromResponse(response));
      });
  }

  function _getAdmissionGroups() {
    if (!$scope.filterUsersForm.venue || !getVenueIdFilter().length) return $q.resolve(null);

    const query = {
      dateStart: dateUtilsService.toUTCTimestampWithoutTime($scope.dateRangePicker.date.startDate),
      dateEnd: dateUtilsService.toUTCTimestampWithoutTime($scope.dateRangePicker.date.endDate),
      type: [
        'GUEST_LIST',
        'TICKET',
        'TALLY'
      ],
      limit: 5000,
      venueId: getVenueIdFilter(),
      status: [
        'CONFIRMED',
        'CHECKED_IN',
        'CHECKED_IN_PARTIAL',
        'CHECKED_IN_FULL',
        'CLOSED',
        'CANCELLED'
      ]
    };

    const attributionId = getAttributionSourceFilter();
    if (attributionId !== ALL_ATTRIBUTION_ID) {
      query.attributionId = attributionId;
    }

    return attributionSourceReportService.list(query)
      .then(admissionGroups => {
        $scope.admissionGroups = admissionGroups.map(admissionGroup => {
          admissionGroup.date = moment.utc(admissionGroup.date, 'x');
          return admissionGroup;
        });

        calculateByUserData();
      })
      .catch(function(error) {
        alertService.error(sdkUtils.getErrorFromResponse(error));
      });
  }

  function calculateByUserData() {
    $scope.guestlistData = [];

    const EMPTY_ATTRIBUTION = {
      id: 'NONE',
      type: 'NONE',
      name: 'None'
    };

    const attributionIdToData = {};

    // add in empty data set for NULL user (maybe replaced with attributionType === NONE?)
    attributionIdToData[EMPTY_ATTRIBUTION.id] = getBaseData(EMPTY_ATTRIBUTION.id, EMPTY_ATTRIBUTION.type, EMPTY_ATTRIBUTION.name);

    //loop through all the admission groups and calculate totals for promoters
    _.each($scope.admissionGroups, function(admissionGroup) {
      let attributionData = null;

      if (admissionGroup.attributionId) {
        // if no attribution data then add an initial data
        if (!(admissionGroup.attributionId in attributionIdToData)) attributionIdToData[admissionGroup.attributionId] = getBaseData(admissionGroup.attributionId, admissionGroup.attributionType, admissionGroup.attributionName); //eslint-disable-line

        attributionData = attributionIdToData[admissionGroup.attributionId];
      } else {
        attributionData = attributionIdToData[EMPTY_ATTRIBUTION.id];
      }

      if (attributionData) {
        attributionData.active = true;
        attributionData.reservations += admissionGroup.guestsExpected || 0;
      }

      if (admissionGroup.spent >= 0) {
        if (admissionGroup.type === 'TICKET') {
          if (attributionData) {
            attributionData.tickets += admissionGroup.guestsExpected;
            attributionData.revenue += admissionGroup.spent;
          }
        } else if (attributionData) {
          attributionData.totalCovers += admissionGroup.guestsCheckedIn;
          attributionData.revenue += admissionGroup.spent;
        }
      }

      //Else count guestlist/cover stats.
      if (admissionGroup.arrived) {
        if (attributionData) attributionData.guestsCheckedIn += admissionGroup.guestsCheckedIn || 0;

        //Count listed genders (based on name only)
        if (admissionGroup.guestsCheckedInMale) {
          if (attributionData) {
            attributionData.guestsCheckedInMale += admissionGroup.guestsCheckedInMale || 0;
          }
        }

        if (admissionGroup.guestsCheckedInFemale) {
          if (attributionData) {
            attributionData.guestsCheckedInFemale += admissionGroup.guestsCheckedInFemale || 0;
          }
        }

        if (admissionGroup.guestsCheckedInUnisex) {
          if (attributionData) {
            attributionData.guestsCheckedInUnisex += admissionGroup.guestsCheckedInUnisex || 0;
          }
        }
      }

      if (attributionData) attributionIdToData[attributionData.id] = attributionData;
    });

    // add attribution calculations to scope data
    _.each(_.values(attributionIdToData), function(data) {
      $scope.guestlistData.push(data);
    });
  }

  function getBaseData(attributionId, attributionType, attributionName) {
    return {
      id: attributionId,
      type: attributionType,
      name: attributionName,
      revenue: 0,
      seated: 0,
      reservations: 0,
      payment: 0,
      minimums: 0,
      guestsCheckedIn: 0,
      guestsCheckedInUnisex: 0,
      guestsCheckedInMale: 0,
      guestsCheckedInFemale: 0,
      compedTickets: 0,
      compedBottles: 0,
      totalCovers: 0,
      tickets: 0,
      active: false
    };
  }

  function _exportData(viewType, $event) {
    if ($event) $event.preventDefault();

    alertService.success('Download should start in a few seconds.');

    if (viewType === 'GUESTLISTS_BY_USER') {
      return generateDataExport('TLPRO_ADMISSION_BY_ATTRIBUTION_DUMP');
    }

    return generateDataExport('TLPRO_ADMISSION_DUMP');
  }

  function generateDataExport(dataExportType) {
    const options = {
      fileType: dataExportType === 'GUESTLIST_BY_ATTRIBUTION_SOURCE_XLSX_DUMP' ? 'XLSX' : 'CSV',
      organizationId: currentUserOrganization.id,
      reportType: dataExportType,
      dateStart: dateUtilsService.toUTCTimestampWithoutTime($scope.dateRangePicker.date.startDate),
      dateEnd: dateUtilsService.toUTCTimestampWithoutTime($scope.dateRangePicker.date.endDate),
      venueId: getVenueIdFilter()
    };

    const attributionId = getAttributionSourceFilter();

    if (attributionId !== ALL_ATTRIBUTION_ID) {
      options.attributionId = attributionId;
    }

    return reportService.create(options);
  }

  function _refreshReport() {
    // $scope.loading = true;

    _getAdmissionGroups()
      .then(function() {
        $scope.loading = false;
      });

    if ($scope.filterUsersForm.venue && $scope.filterUsersForm.venue.id !== ALL_VENUES_ID) {
      $scope.getAdmissionGroupStatsByVenueId($scope.filterUsersForm.venue.id, dateUtilsService.toUTCMomentWithoutTime($scope.dateRangePicker.date.startDate), dateUtilsService.toUTCMomentWithoutTime($scope.dateRangePicker.date.endDate), {
        attributionId: $scope.filterUsersForm.attributionSource && $scope.filterUsersForm.attributionSource.id !== 'ALL_ATTRIBUTION_ID' ? $scope.filterUsersForm.attributionSource.id : null
      });
    } else {
      $scope.getAdmissionGroupStatsByOrganizationId(dateUtilsService.toUTCMomentWithoutTime($scope.dateRangePicker.date.startDate), dateUtilsService.toUTCMomentWithoutTime($scope.dateRangePicker.date.endDate), {
        attributionId: $scope.filterUsersForm.attributionSource && $scope.filterUsersForm.attributionSource.id !== 'ALL_ATTRIBUTION_ID' ? $scope.filterUsersForm.attributionSource.id : null
      });
    }
  }

  function getAttributionSourceFilter() {
    if ($scope.filterUsersForm.attributionSource && $scope.filterUsersForm.attributionSource.id !== ALL_ATTRIBUTION_ID) {
      return $scope.filterUsersForm.attributionSource.id;
    }

    return ALL_ATTRIBUTION_ID;
  }

  function getVenueIdFilter() {
    return $scope.filterUsersForm.venue.id === ALL_VENUES_ID ? _.pluck(_.filter($scope.venues, venue => venue.id !== ALL_VENUES_ID), 'id') : $scope.filterUsersForm.venue.id;
  }

  _initScope();

  _loadData();
}

PerformanceGuestListCtrl.$inject = [
  '$scope',
  '$stateParams',
  '$location',
  '$q',
  '$sce',
  'jsSdk.venue',
  'jsSdk.utils',
  'jsSdk.admissionGroup',
  'jsSdk.attributionSource',
  'jsSdk.attributionSourceReport',
  'permissionService',
  'organizationService',
  'managementUserOrganizationMemberService',
  'alertService',
  'utilsService',
  'dateUtilsService',
  'pubsubService',
  'ERROR_MESSAGES',
  'TRACKING_EVENT_CATEGORIES',
  'reportService'
];

export default PerformanceGuestListCtrl;



// WEBPACK FOOTER //
// ./src/components/performanceGuestList/performanceGuestListCtrl.js